import {
    ODataHeader,
    ODataString,
    ODataDateTime,
    ODataDate
} from "pbas-vue-components";

const DemographicsArchiveHeaders = [
    new ODataHeader({
        type: new ODataString("Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        isIdentifier: true,
        version: 1
    }),
    new ODataHeader({
        title: "globals.date",
        type: new ODataDate("Date"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        type: new ODataString("PlanIdentityId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        title: "globals.insurance_carrier",
        type: new ODataString("PlanInsuranceCarrier/InsuranceCarrier/Name"),
        sortable: true,
        visible: true,
        searchable: true,
    }),
    new ODataHeader({
        type: new ODataString("PlanInsuranceCarrier/Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        title: "globals.timestamp",
        type: new ODataDateTime("Timestamp"),
        sortable: true,
        visible: true,
        searchable: true,
    }),
    new ODataHeader({
        title: "headers.pension_regulators.user",
        type: new ODataString("CreatorEmail"),
        sortable: true,
        visible: true,
        searchable: true,
    }),
];
export default DemographicsArchiveHeaders;